import * as React from 'react';

import clsx from 'clsx';

/**
 * IconBox — decorative wrapper for SVG icons.
 * Used for beautiful icon styling (background, border, shadow, rounding, etc.),
 * for example, in empty state, avatar, cards, etc.
 * Not a universal wrapper for all icons!
 * Icon size is determined through parent font-size or style cascade.
 */
export type IconBoxSize = 'small' | 'medium' | 'large';
export type IconBoxColor =
  | 'default'
  | 'primary'
  | 'error'
  | 'warning'
  | 'info'
  | 'success';

export interface IconBoxProps extends React.HTMLAttributes<HTMLSpanElement> {
  size?: IconBoxSize;
  color?: IconBoxColor;
  children: React.ReactNode;
}

export const IconBox: React.FC<IconBoxProps> = ({
  size = 'medium',
  color = 'default',
  children,
  className,
  ...rest
}) => {
  return (
    <span
      className={clsx(
        'icon-box',
        `icon-box-size-${size}`,
        `icon-box-color-${color}`,
        className
      )}
      {...rest}
    >
      {children}
    </span>
  );
};
